// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class GetAccountResponseModel {
    static getAttributeTypeMap() {
        return GetAccountResponseModel.attributeTypeMap;
    }
}
GetAccountResponseModel.discriminator = undefined;
GetAccountResponseModel.attributeTypeMap = [
    {
        "name": "account",
        "baseName": "account",
        "type": "AccountModel"
    },
    {
        "name": "patient",
        "baseName": "patient",
        "type": "PatientModel"
    }
];
//# sourceMappingURL=getAccountResponseModel.js.map